import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "circle.plus", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("circle", { fillOpacity: 0.1, fill: "currentColor", cx: 10, cy: 10, r: 9 }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M10 6v8m-4-4h8" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
